import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import Button from '../../../../../../../../../../../../../../../../components/button';
import {
	enteredCollaboratorSearchValue, getChangedStatus,
	selectedCollaborator, updateCollaborators
} from '../../../../../../../../../../../../../../../../../actions/sharingDetailsActions';
import {
    domainGroupNextPage,
    resetDomainGroup
} from '../../../../../../../../../../../../../../../../../actions/domainGroupActions';
import './index.css';

class GetBackButton extends React.Component {

	constructor(props){
		super(props);

		this.goBack = this.goBack.bind(this);
	}

	goBack(){
		this.props.setSelectedCollaborator(null);
		this.props.resetDomainGroup();
		this.props.enteredCollaboratorSearchValue("");
		this.props.domainGroupNextPage(2);

		if(this.props.updateCollaborators.length > 0){
			this.props.setUpdateCollaborators([]);
		}

		if (this.props.changedStatus){
			this.props.setChangedStatus(false);
		}

		document.querySelector('.data-list__head input').value = "";
	}

	render() {
		if(this.props.selectedCollaborator !== null){
			return (
				<div className="getback-button">
					<Button onClick={this.goBack} className="btn-link">
						&laquo;&nbsp;
						{this.props.t("getBackText")}
					</Button>
				</div>
			)
		} else {
			return null
		}

	}
}

const mapStateToProps = (state) => {
	return {
		selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		changedStatus: state.sharingDetailsReducer.getChangedStatus
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		resetDomainGroup : () => {
			dispatch(resetDomainGroup())
		},
		setSelectedCollaborator : (object) => {
			dispatch(selectedCollaborator(object))
		},
		enteredCollaboratorSearchValue : (string) => {
			dispatch(enteredCollaboratorSearchValue(string))
		},
        domainGroupNextPage : (int) => {
            dispatch(domainGroupNextPage(int))
        },
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
		setChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GetBackButton));